import type { Lottery } from '@lotta/shared/types-lottery-schemas';
import { getDrawDates } from '@lotta/shared/util-draws';
import type { Expand } from '@lotta/shared/util-utilities';

type RequiredLotteryProps = Expand<
  Pick<Lottery, 'lotteryStatus' | 'occurrence' | 'drawDay' | 'drawTime'>
>;

/**
 * Edit Lottery
 *
 * Possible until first signup period has ended
 */
export const isEditLotteryAllowed = (
  lottery: RequiredLotteryProps,
  timezone: string,
  date: Date
) => {
  if (lottery.lotteryStatus !== 'PENDING') {
    return false;
  }

  const drawDates = getDrawDates(lottery, timezone);

  // Allowed if first signup period has not ended
  return new Date(drawDates[0].endDate) >= date;
};
